export default __webpack_public_path__ + "static/media/withdraw.71317edb.svg";